import env from '../config/env';
import CancelCreditEligible from '../interfaces/dto/cancelCreditEligibleDTO';
import { get, post } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';

const getCancelCreditEligible = async (): Promise<CancelCreditEligible> => {
  const url = apiPaths.getCancelCreditEligible;
  return get(env.GROWTH_API_URL || 'https://growth-api.fabfitfun.com', url).then(
    (response) => response.data,
  );
};

const postCancelCredit = async (): Promise<void> => {
  const url = apiPaths.postCancelCredit;
  return post(env.GROWTH_API_URL || 'https://growth-api.fabfitfun.com', {}, url).then(
    (response) => response.data,
  );
};

export { getCancelCreditEligible, postCancelCredit };
